import { createSlice } from '@reduxjs/toolkit';
import { SharedAppState } from '../../store.shared';
import { UnknownAnimalsState } from './types';
import { getUnknownAnimals, mapUnknownAnimals } from './operation';
import { removeMultipleValuesFromArray } from 'shared/helpers/reducer-helpers';


const initialState: UnknownAnimalsState = {
	unknownAnimals: [],
	pending: false,
};

const unknownAnimalsReducer = createSlice({
	name: 'unknownAnimals',
	initialState,
	reducers: {

	},
	extraReducers: builder => {
		builder.addCase(getUnknownAnimals.pending, state => {
			state.pending = true;
		});
		builder.addCase(getUnknownAnimals.fulfilled, (state, action) => {
			state.unknownAnimals = action.payload;
			state.pending = false;
		});
		builder.addCase(getUnknownAnimals.rejected, state => {
			state.pending = false;
		});
		builder.addCase(mapUnknownAnimals.pending, state => {
			state.pending = true;
		});
		builder.addCase(mapUnknownAnimals.fulfilled, (state, action) => {
			state.unknownAnimals = removeMultipleValuesFromArray(state.unknownAnimals, action.payload);
			state.pending = false;
		});
		builder.addCase(mapUnknownAnimals.rejected, state => {
			state.pending = false;
		});
	},
});

export default unknownAnimalsReducer.reducer;
